import { ChainId, IS_TESTNET, chainInfo } from "@looksrare/config";

type YOLOGamesSupportedChainId = ChainId.BLAST_SEPOLIA | ChainId.BLAST_MAINNET;

export const getDefaultChain = (): YOLOGamesSupportedChainId => {
  return IS_TESTNET ? ChainId.BLAST_SEPOLIA : ChainId.BLAST_MAINNET;
};

export const getChainInfo = () => chainInfo[getDefaultChain()];
